import { FC } from "react";

import { css } from "@compiled/react";
import { useIntl } from "react-intl";

import { wacToken } from "@/libraries/design/foundations";
import { experiments, ExperimentView } from "@/utils/experiment";

export interface Jfind1315SubHeadingProps {
    returnString?: boolean;
    controlText?: string;
}

// JFIND experiment in confluence
export const Jfind1315SubHeading: FC<Jfind1315SubHeadingProps> = ({
    returnString,
    controlText
}) => {
    const intl = useIntl();

    const jfind1315SubHeaderText = intl.formatMessage({
        id: "BxpSignup.accountCreation.subHeading.startForFree",
        defaultMessage: "Start for free. No credit card needed."
    });

    const controlSubHeaderText =
        controlText ||
        intl.formatMessage({
            id: "signupForm.accountCreation.subHeaderText",
            defaultMessage:
                "It’s free for up to 10 users - no credit card needed."
        });

    return (
        <ExperimentView
            experiment={experiments.jfind1315RemoveExpectationOfFreeConfluence}
            render={(value) => {
                if (value) {
                    return returnString ? (
                        jfind1315SubHeaderText
                    ) : (
                        <p css={subHeaderCss}>{jfind1315SubHeaderText}</p>
                    );
                } else {
                    return returnString ? (
                        controlSubHeaderText
                    ) : (
                        <p css={subHeaderCss}>{controlSubHeaderText}</p>
                    );
                }
            }}
        />
    );
};

const subHeaderCss = css({
    color: wacToken("color.primary.black"),
    margin: "0 0 24px",
    textAlign: "center"
});
